export default function MySQL_POW() {
  return (
    <div>
      <h2>MySQL_POW</h2>    </div>
  );
}